import React from "react";
import "./index.scss";

const Notification = ({ count }) => {
  return (
    <span className="fa-stack notification-bubble">
      <i className="fa fa-circle fa-stack-2x document-count-bubble"></i>
      <strong className="fa-stack-1x document-count-text">{count}</strong>
    </span>    
  );
};
export default Notification;
